import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import React, { useState } from "react";

import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import DashboardSelectionForm from "components/SelectionForm/DashboardSelectionForm";
import InvertedTable from "components/Table/InvertedTable";
import PageTitle from "components/PageTitle/PageTitle";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { excelDownload } from "utils/excelDownload";
import LoaderBar from "components/LoaderBar/LoaderBar";
import { buildDynamicPanelTable } from "./dynamicPanelTable";
import useStyles from "./styles";

export default function KPIsDashboard() {
  const [snackbarStatus, , onCloseSnackbar] = SnackbarHandler();
  const classes = useStyles();
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialState, setIsInitialState] = useState(true);
  const [excelTotalsData, setExcelTotalsData] = useState([]);

  const exportDataInTwoFiles = () => {
    let totalColumns = ["Concepto", ...columns];
    let formattedColumns = totalColumns.map((column) => {
      return { name: column };
    });
    excelDownload(
      formattedColumns,
      excelTotalsData,
      0,
      formattedColumns.length,
      "Panel de Auditorias",
    );
  };

  const generateRowsData = (data) => {
    if (!data?.columns_groups_order || !data?.formatted_data) {
      setColumns([]);
      setRows([]);
      setExcelTotalsData([]);
      return;
    }

    const table = buildDynamicPanelTable({
      columnsGroupsOrder: data.columns_groups_order,
      formattedData: data.formatted_data,
    });
    setColumns(table.columns);
    setRows(table.rows);
    setExcelTotalsData(table.excelRows);
  };

  const renderTables = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          lg={12}
          style={{ marginBottom: "2%", marginTop: "2%", marginLeft: "2.5%" }}
        >
          <Typography variant="h4" className={classes.alignedText}>
            Valores
          </Typography>
          <Divider />
        </Grid>
        <Paper style={{ marginTop: "30px" }}>
          <InvertedTable
            title="Concepto"
            rows={rows}
            columns={columns}
            formatGoalCells={false}
          />
        </Paper>
      </>
    );
  };

  const renderLoadingSection = () => {
    return (
      <Grid
        item
        container
        justifyContent="center"
        xs={12}
        style={{ paddingTop: "2%" }}
      >
        <LoaderBar />
      </Grid>
    );
  };

  const defineSectionToShow = () => {
    if (isLoading) return renderLoadingSection();
    if (isInitialState) return <></>;
    return renderTables();
  };

  return (
    <Grid>
      <PageTitle title="Panel de control - Auditoría Tradicionales + Quemables" />
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Paper elevation={3}>
        <Grid
          container
          xs={12}
          md={12}
          lg={12}
          layout={"row"}
          spacing={"1"}
          style={{ border: "1px" }}
        >
          <DashboardSelectionForm
            generateRowsData={generateRowsData}
            setIsInitialState={setIsInitialState}
            setIsLoading={setIsLoading}
            exportFunction={exportDataInTwoFiles}
            isLoading={isLoading}
            isInitialState={isInitialState}
          />
        </Grid>
      </Paper>
      {defineSectionToShow()}
    </Grid>
  );
}